<template>
  <el-dialog v-dialogDrag
             title="修改密码"
             key="UU-PW"
             :visible.sync="visible"
             width="50%"
             :modal="false"
             center
             :before-close="handleClose"
  >
    <el-form :inline="false" :model="dataObject" label-width="140px">
      <el-form-item label="原始密码">
        <el-input type="password" v-model="dataObject.oldPassword"></el-input>
      </el-form-item>
      <el-form-item label="新密码">
        <el-input type="password" v-model="dataObject.newPassWord"></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input type="password" v-model="dataObject.checkNewPassWord"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="update">修  改</el-button>
        <el-button @click="handleClose">返  回</el-button>
      </span>
  </el-dialog>
</template>

<script>
import {updateStaffPassword} from "../api/api";

export default {
  name: "updateUserPassword",
  props:["visible", "userCode"],
  data:function(){
    return{
      dataObject:{
        oldPassword:"",
        newPassWord:"",
        checkNewPassWord:"",
      },
    }
  },
  watch:{

  },
  methods:{
    update(){
      if(this.dataObject.newPassWord !== this.dataObject.checkNewPassWord){
        this.$message.error('新密码和确认密码不一致！');
        return;
      }

      let params = {
        staffCode: this.userCode,
        oldPassword:this.dataObject.oldPassword,
        newPassWord:this.dataObject.newPassWord,
      }

      updateStaffPassword(params).then(res =>{
        if(res.success){
          this.$message.success(res.data);
          this.handleClose();
        }else{
          this.$message.error(res.data);
        }
      }).catch(error=>{
        this.$message.error('请求出错，请稍后重试！');
      });

    },
    handleClose(){
      this.dataObject = {
        oldPassword:"",
        newPassWord:"",
        checkNewPassWord:"",
      }
      this.$emit("close");
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// updateUserPassword.vue?75d4686b